<template>
  <div>
    <h3>Welcome to the Exhibitor Center</h3>
    <el-card class="box-card">
      <div class="text item">
        {{ userInfo.atrEName || userInfo.atrName }}
      </div>
      <div class="text item">Hall：{{ userInfo.srmName }}</div>
      <div class="text item">Booth No：{{ userInfo.bthCode }}</div>
      <div class="text item">Area：{{ userInfo.bthArea+"㎡"  }}</div>
    </el-card>
    <ul>
      <li>
        <p>We have designed this Exhibitor Manual to assist you in your pre-show preparations. <br/>We strongly advise exhibitors to read the handbook carefully and to observe the application deadlines for each service. </p>
        <p>Our services include the following three categories, each with a corresponding application form：</p>
        <ol>
          <li>● Technical Services & Logistics</li>
          <li>● Accommodation & Travel</li>
          <li>● Certificates & Approval procedure for Workers of Erection / Transport Contractor</li>
        </ol>
        <p>For all service applications, you only need to fill out the forms, sign and send them to the service company at the top of the form. And please also remember to keep a copy of the forms. <br/>
          If you have any questions, please contact the person designated on the form. </p>
        <p>We appreciate your company's participation at China International Fruit Expo 2024 and wish you great success during the expo. </p>
        <p>Yours sincerely!</p>
        <p style="font-weight:bold">China International Fruit Expo 2024 Organizing Committee</p>

      </li>
     
      <!-- <li>阅读平台相关信息，并遵守各项服务的截止日期，部分标有“必填”字样的内容请优先填写。</li>
      <li>对于各项服务申请，您只需线上正确填写。若有任何问题，请联系表格中指定的负责人或主办方。</li>
      <li>我们期待着您的到来。祝您在展会上取得成功！</li>
      <li>为保护您的信息安全，30分钟未操作，系统将自动注销。</li> -->
      <br />
      <strong>Today is {{ today }}， Countdown {{ inDays }} Days。</strong>
    </ul>
    <el-divider></el-divider>
    <el-table :data="infoTable" style="width: 100%" v-if="false">
      <el-table-column prop="fstName" label="Project" >

        <template slot-scope="scope">
          <span  style="cursor: pointer" v-if="scope.row.fstName == '参展证申请' ">
            Card Application
          </span>
          <span style="cursor: pointer" v-if="scope.row.fstName == '会刊信息' ">
            Journal information
          </span>
          <span style="cursor: pointer" v-if="scope.row.fstName == '新品上传' ">
            Exhibition upload
          </span>
          <!-- <span style="cursor: pointer" v-else>
            {{scope.row.fstName}}
          </span> -->
        </template>

      </el-table-column>
      <el-table-column label="Importance">
        <template slot-scope="scope">
          <span>{{ scope.row.isRequired ? 'Required' : 'Not mandatory' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="fstEDate" label="Deadline">
        <template slot-scope="scope">
          <span>{{ format(scope.row.fstEDate) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="subDate" label="Submission date">
        <template slot-scope="scope">
          <span>{{ format(scope.row.subDate) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import api from '@/api'
import moment from 'moment'
moment.locale('zh-cn')
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      exhInfo: {},
      // today: moment().format('YYYY年MM月DD日'),
      today:'',
      inDays: '',
      infoTable: [],
      month:['January','February','March','April','May','June','July','August','September','October','November','December']
    }
  },
  methods: {
    format(data) {
      if (data !== null){
        return moment(data).format('YYYY-MM-DD')
      } else {
        return ''
      }
    }
  },
  mounted() {
    var _tempDay = moment().format('YYYY/M/DD')
    
    _tempDay = _tempDay.split('/')
    this.today = this.month[parseInt(_tempDay[1]-1)]+" "+ _tempDay[2]+","+ _tempDay[0]


    api.getexhinfo().then((res) => {
      // this.inDays = moment(res.data.data.exhbtime).toNow(true)
      this.inDays = moment(res.data.data.exhbtime).diff(new Date(), 'day')
      this.inDays +=1
    })

    api.getformsetting().then((res) => {
      this.infoTable = res.data.data
    })
  }
}
</script>

<style lang="less" scoped>
.box-card {
  margin: 20px 0 20px 0;
}
.item {
  padding: 8px 0;
  font-size:14px
}
li, strong {
  line-height: 2;
  font-size:14px;
}
.page-warp h3{
  font-size:14px
}
@media screen and (max-width:540px){

}
</style>
